module.exports = __webpack_public_path__ + "img/tv_tuning.c297a6fd.png";